import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchReset } from '../../actions/fetch.actions';
import { INPUT_STATES } from '../../components/forms/forms.utils';
import TextField from '../../components/forms/TextField';
import { useForm } from '../../hooks/useForm.hook';
import { ADMIN_OFFERING_THEMES_RESOURCE } from '../../resources/admin/admin.offering.themes.resource';
import themesService from '../../services/api/themes.service';
import Modal from '../Modal';
import ModalTitle from '../ModalTitle';

const INPUT_NAME = 'spo-add-theme-textfield';

const AddThemeModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { data, isSubmitting, input, submitStart, submitOk, submitError, error } = useForm({ name: '' });

  const handleConfirm = () => {
    submitStart();
    themesService.add(data, {
      onSuccess: () => {
        submitOk();
        dispatch(fetchReset(ADMIN_OFFERING_THEMES_RESOURCE));
        handleClose();
      },
      onError: (message) => submitError(message)
    });
  };

  const handleClose = () => {
    input('', 'name');
    onClose();
  };

  const handleEnter = (event) => {
    if (event.code === 'Enter' && !!data?.name) {
      handleConfirm();
    }
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        document.getElementsByName(INPUT_NAME)?.[0]?.focus();
      }, 10);
    }
  }, [isOpen]);

  return (
    <Modal
      className="spo-o-add-theme-modal"
      title={<ModalTitle hasError={!!error} title="Label toevoegen" />}
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      canConfirm={!!data?.name}
      isSubmitting={isSubmitting}
      onConfirmLabel="Toevoegen"
      onConfirmIcon="ai-check-1"
    >
      <TextField
        label="Naam"
        name={INPUT_NAME}
        value={data.name}
        state={INPUT_STATES.DEFAULT}
        onKeyDown={handleEnter}
        onChange={(value) => input(value, 'name')}
        disabled={isSubmitting}
      />
      {!!error && <p className="u-text-danger">{error}</p>}
    </Modal>
  );
};

export default AddThemeModal;
